import Log from '~/_Utility/Log';

import Async from '~/Async';

class History {

    /**
     * @since 2.31.0
     * @method constructor
     */
    constructor() {
        // Get our async requestor
        this.async = new Async();

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.31.0
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('History initialized.', 'init');

        // Do not run this on the login page for guests
        if ($('body').is('.woocommerce-account.p3-user-guest'))
            return new Log('History state not set for this page.');

        // Run the async post
        this.async.post('history-step', {
            routine: 'history-step',
            params:  {
                url:       window.location.href,
                isPage:    $('body').hasClass('page') ? 'on' : '',
                isSingle:  $('body').hasClass('single') ? 'on' : '',
                isArchive: $('body').hasClass('post-type-archive') ? 'on' : ''
            }
        });
    }
}

export default History;